import Vue from 'vue';
import VueRouter from 'vue-router'
Vue.use(VueRouter);

import Notice from '../components/Notice'
import Home from '../components/Home'
import Profile from '../components/Profile'
import Resume from '../components/Resume'
import Recruit from '../components/Recruit'
import Detail from '../components/Detail'
import Preaching from '../components/Preaching'
import Administer from '../components/Administer'

const routes=[
    {path:'/',redirect:'/home'},
    // {path:'/notice', component:Notice},
    //
    {path:'/home', component:Home},
    {path:'/profile', component:Profile},
    {path:'/recruit', component:Recruit},
    {path:'/preaching', component:Preaching},
    {path:'/resume', component:Resume},
    {path:'/detail/:id', component:Detail,name:'detail'},
    {path:'/administer', component:Administer},
    {path:'*',redirect:'/notice'}
]

const router = new VueRouter({
    routes
})

export default router;